<template>
  <div class="h-remove-child-margin">
    <p>{{ text }}</p>
    <p class="confirmation-popup__actions">
      <button class="a-btn-primary" v-for="action in actions" :key="action.key" @click="action.click" type="button">{{ action.label }}</button>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true
    },
    actions: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss">
.confirmation-popup {
  &__actions {
    * {
      margin: 0 10px 10px 0;
    }
  }
}
</style>
